import { ConsultationContact, RecentContact } from '../../vendors/consult/types/consultation';

const RECENT_STORAGE_KEY = 'consult_recent_contacts';

/**
 * Save recent contacts to localStorage
 */
export function saveRecentContacts(recent: RecentContact[]): void {
  try {
    const limited = recent.slice(0, 20);
    localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(limited));
  } catch (error) {
    console.error('Error saving recent contacts to localStorage:', error);
  }
}

/**
 * Load recent contacts from localStorage
 */
export function loadRecentContacts(): RecentContact[] {
  try {
    const data = localStorage.getItem(RECENT_STORAGE_KEY);
    if (data) {
      return JSON.parse(data) as RecentContact[];
    }
  } catch (error) {
    console.error('Error loading recent contacts from localStorage:', error);
  }
  return [];
}

/**
 * Add contact to recent list
 */
export function addToRecent(contact: ConsultationContact): RecentContact[] {
  const recent = loadRecentContacts();
  const filtered = recent.filter((c) => c.targetId !== contact.targetId);
  const updated: RecentContact[] = [
    {
      ...contact,
      lastAccessed: new Date().toISOString()
    },
    ...filtered
  ];
  saveRecentContacts(updated);
  return updated;
}

